import { render, staticRenderFns } from "./FormValuePreview.vue?vue&type=template&id=126b0541&scoped=true&"
import script from "./FormValuePreview.vue?vue&type=script&lang=ts&"
export * from "./FormValuePreview.vue?vue&type=script&lang=ts&"
import style0 from "./FormValuePreview.vue?vue&type=style&index=0&id=126b0541&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126b0541",
  null
  
)

export default component.exports